<template>
  <div>
    <!-- Edit -->
    <a-drawer
      :title="'Edit Student ' + (!statusChecked ? '(Inactive)' : '')"
      :width="
        this.settings['isMobileView']
          ? 480
          : this.settings['isTabletView']
          ? 720
          : 1080
      "
      @close="handleCancel"
      :visible="visible"
      :wrapStyle="{
        height: 'calc(100% - 10px)',
        overflow: 'auto',
        paddingBottom: '10px',
      }"
      placement="right"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <a-skeleton
        active
        :title="false"
        :paragraph="{ rows: 30 }"
        :loading="loading"
      />
      <a-form class="mb-4" :form="form" v-show="!loading">
        <a-collapse
          v-model="activeKey"
          :bordered="false"
          :destroyInactivePanel="false"
        >
          <a-collapse-panel key="1" header="Basic Details">
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item label="Student Code">
              <a-input
                placeholder="Student Code"
                v-decorator="[
                  'student_code',
                  {
                    rules: [
                      { required: true, message: 'Please input student code!' },
                    ],
                  },
                ]"
                :disabled="false"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="First name">
              <a-input
                placeholder="First name"
                v-decorator="[
                  'first_name',
                  {
                    rules: [
                      { required: true, message: 'Please input first name!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="Last name">
              <a-input
                placeholder="Last name"
                v-decorator="[
                  'last_name',
                  {
                    rules: [
                      { required: false, message: 'Please input last name!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Date of birth">
              <a-date-picker
                v-decorator="[
                  'dob',
                  {
                    rules: [
                      { required: true, message: 'Please input date of birth' },
                    ],
                    initialValue: moment(),
                  },
                ]"
                :disabled-date="disabledDate"
                :format="dateFormat"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="System Id(Biometrics)">
              <a-input
                placeholder="System Id"
                v-decorator="[
                'system_student_id',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input system id!',
                    },
                    ],
                  },
                ]"
                />
                </a-form-item>
              </div>

          <div class="col-md-4">
            <a-form-item label="Nationality">
              <a-input
                placeholder="Nationality"
                v-decorator="[
                  'nationality',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input a nationality!',
                      },
                    ],
                    initialValue: 'Indian',
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Religion">
              <a-input
                placeholder="Religion"
                v-decorator="[
                  'religion',
                  {
                    rules: [
                      { required: false, message: 'Please input a religion!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Gender">
              <a-radio-group
                v-decorator="[
                  'gender',
                  {
                    rules: [
                      { required: false, message: 'Please select a gender!' },
                    ],
                    initialValue: 'M',
                  },
                ]"
              >
                <a-radio
                  v-for="genderType in genderTypes"
                  :value="genderType.value"
                  :key="genderType.value"
                  class="mr-2"
                >
                  <span class="text-bold">{{ genderType.name }}</span>
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Category">
              <a-radio-group
                v-decorator="[
                  'category',
                  {
                    rules: [
                      { required: false, message: 'Please select a category!' },
                    ],
                    initialValue: 'GEN',
                  },
                ]"
              >
                <a-radio
                  v-for="categoryType in categoryTypes"
                  :value="categoryType.value"
                  :key="categoryType.value"
                  class="mr-2"
                >
                  <span class="text-bold">{{ categoryType.name }}</span>
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Mother Tongue">
              <a-input
                placeholder="Language"
                v-decorator="[
                  'language',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input mother tongue!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Aadhaar No.">
              <a-input
                placeholder="Aadhaar No."
                v-decorator="[
                  'aadhaar_no',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input aadhaar number!',
                        pattern: new RegExp(`^[0-9]{12}$`),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="PEN No">
              <a-input
                placeholder="PEN No."
                v-decorator="[
                  'pen_no',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input PEN number!',
                        pattern: new RegExp(`^[0-9]{11}$`),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="APAAR-ID">
              <a-input
                placeholder="APAAR ID."
                v-decorator="[
                  'apaar_id',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input APAAR-ID!',
                        pattern: new RegExp(`^[0-9]{12}$`),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Board Registration No">
              <a-input
                placeholder="Board Registration No"
                v-decorator="[
                  'student[meta][board_10th_reg_no]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input Board Registration No!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="SIC">
              <a-checkbox-group
                v-decorator="[
                  'sic',
                  {
                    rules: [{ required: false, message: 'Please select!' }],
                    initialValue: [],
                  },
                ]"
              >
                <a-checkbox
                  v-for="option in sicOptions"
                  :value="option.value"
                  :key="option.value"
                  class="mr-2"
                >
                  <span class="text-bold">{{ option.name }}</span>
                </a-checkbox>
              </a-checkbox-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="AAY Beneficiary">
              <a-radio-group
                v-decorator="[
                  'student[meta][aay]',
                  { rules: [{ required: false }], initialValue: 0 },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="CWSN (Children with Special Needs)">
              <a-radio-group
                v-decorator="[
                  'student[meta][cwsn]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select CWSN status!',
                      },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>

              <div
                v-show="form.getFieldValue('student[meta][cwsn]') === 1"
                class="mt-2"
              >
                <a-form-item label="Facilities Provided">
                  <a-input
                    v-decorator="[
                      'student[meta][cwsn_facility]',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please describe facilities provided!',
                          },
                        ],
                      },
                    ]"
                    placeholder="e.g., Special seating, assistive devices"
                  />
                </a-form-item>
              </div>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Competition/Olympiad Participation">
              <a-radio-group
                v-decorator="[
                  'student[meta][competition_appeared]',
                  { rules: [{ required: false }], initialValue: 0 },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>
              <div
                v-show="
                  form.getFieldValue('student[meta][competition_appeared]') ===
                  1
                "
                class="mt-2"
              >
                <a-form-item label="Competition/Olympiad type">
                  <a-input
                    v-decorator="[
                      'student[meta][competition_type]',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please describe competition type!',
                          },
                        ],
                      },
                    ]"
                    placeholder="e.g.,Math Olympiad, Science Fair"
                  />
                </a-form-item>
              </div>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Specific Learning Disability (SLD)">
              <a-radio-group
                v-decorator="[
                  'student[meta][sld]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select SLD status!',
                      },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>

              <div
                v-show="form.getFieldValue('student[meta][sld]') === 1"
                class="mt-2"
              >
                <a-form-item label="SLD type">
                  <a-input
                    v-decorator="[
                      'student[meta][sld_facility]',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please describe SLD type!',
                          },
                        ],
                      },
                    ]"
                    placeholder="e.g., Extra time for exams, specialized tutoring"
                  />
                </a-form-item>
              </div>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="EWS/Disadvantaged Group">
              <a-radio-group
                v-decorator="[
                  'student[meta][ews]',
                  { rules: [{ required: false }], initialValue: 0 },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Autism Spectrum Disorder (ASD)">
              <a-radio-group
                v-decorator="[
                  'student[meta][asd]',
                  { rules: [{ required: false }], initialValue: 0 },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item
              label="Attention Deficit Hyperactivity Disorder (ADHD)"
            >
              <a-radio-group
                v-decorator="[
                  'student[meta][adhd]',
                  { rules: [{ required: false }], initialValue: 0 },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Identified as Gifted/Talented?">
              <a-radio-group
                v-decorator="[
                  'student[meta][gifted]',
                  { rules: [{ required: false }], initialValue: 0 },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </div>

          </a-collapse-panel>

          <a-collapse-panel key="2" header="Contact Details">
        <div class="row pb-3">
          <div class="col-md-9">
            <a-form-item label="Address">
              <a-input
                placeholder="Street address"
                v-decorator="[
                  'student[contact][address]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input school address!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="City">
              <a-input
                placeholder="City"
                v-decorator="[
                  'student[contact][city]',
                  {
                    rules: [{ required: false, message: 'Please input city!' }],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="District">
              <a-input
                placeholder="District"
                v-decorator="[
                  'student[contact][district]',
                  {
                    rules: [
                      { required: false, message: 'Please input a district!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Landmark">
              <a-input
                placeholder="Landmark"
                v-decorator="[
                  'student[contact][landmark]',
                  {
                    rules: [
                      { required: false, message: 'Please input a landmark!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Pincode">
              <a-input
                placeholder="Pincode"
                v-decorator="[
                  'student[contact][pincode]',
                  {
                    rules: [
                      { required: false, message: 'Please input a pincode!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="State">
              <a-input
                placeholder="State"
                v-decorator="[
                  'student[contact][state]',
                  {
                    rules: [
                      { required: false, message: 'Please input a state!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Country">
              <a-input
                placeholder="Country"
                v-decorator="[
                  'student[contact][country]',
                  {
                    rules: [
                      { required: false, message: 'Please input a country!' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-3">
            <a-form-item label="Phone">
              <a-input
                placeholder="Phone"
                v-decorator="[
                  'student[contact][phone]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input a valid phone!',
                        pattern: new RegExp(`^[0-9]{7,14}$`),
                      },
                    ],
                  },
                ]"
                width="100%"
              >
                <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'student[contact][country_code]',
                    { initialValue: '91' },
                  ]"
                  style="width: 70px"
                >
                  <a-select-option
                    v-for="countryCode in countryCodes"
                    :value="countryCode.value"
                    :key="countryCode.value"
                  >
                    <span class="text-bold">{{ countryCode.name }}</span>
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Alt. Phone">
              <a-input
                placeholder="Alt. Phone"
                v-decorator="[
                  'student[contact][alt_phone]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input an valid alt phone!',
                        pattern: new RegExp(`^[0-9]{7,14}$`),
                      },
                    ],
                  },
                ]"
                width="100%"
              >
                <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'student[contact][alt_country_code]',
                    { initialValue: '91' },
                  ]"
                  style="width: 70px"
                >
                  <a-select-option
                    v-for="countryCode in countryCodes"
                    :value="countryCode.value"
                    :key="countryCode.value"
                  >
                    <span class="text-bold">{{ countryCode.name }}</span>
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Email">
              <a-input
                placeholder="Email"
                v-decorator="[
                  'student[contact][email]',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'The input is not valid email!',
                      },
                      {
                        required: false,
                        message: 'Please input an email!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>

          </a-collapse-panel>

          <a-collapse-panel key="3" header="Enrollment Details">
        <div class="row pb-3">
          <!-- Select Session  -->
          <div class="col-md-4">
            <a-form-item label="Session">
              <a-select
                v-decorator="[
                  'session_id',
                  {
                    rules: [
                      { required: true, message: 'Please select a session!!' },
                    ],
                    initialValue: currentSession ? currentSession.id : '',
                  },
                ]"
                placeholder="Select session"
                :disabled="true"
              >
                <a-select-option
                  v-for="schoolSession in schoolSessions"
                  :value="schoolSession.id"
                  :key="schoolSession.id"
                >
                  {{ schoolSession.name }}
                  <small class="text-primary ml-3">{{
                    currentSession.id === schoolSession.id ? "Current" : ""
                  }}</small>
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- Select Class -->
          <div class="col-md-4">
            <a-form-item label="Class">
              <a-spin :spinning="classSpinning">
                <a-select
                  v-decorator="[
                    'enrollment[class_id]',
                    {
                      rules: [
                        { required: false, message: 'Please select a class!!' },
                      ],
                    },
                  ]"
                  placeholder="Select class"
                  @change="handleClassSelect"
                >
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option
                      v-if="schoolClass.class_sections_count > 0"
                      :value="schoolClass.id"
                      :key="schoolClass.id"
                    >
                      {{ schoolClass.name }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>
          <!-- Select Section -->
          <div class="col-md-4">
            <a-form-item label="Section">
              <a-spin :spinning="sectionSpinning">
                <a-select
                  v-decorator="[
                    'enrollment[section_id]',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please select a section!!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Select section"
                >
                  <a-select-option
                    v-for="section in sections"
                    :value="section.id"
                    :key="section.id"
                  >
                    {{ section.name }}
                  </a-select-option>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Roll Number">
              <a-input
                placeholder="Roll number"
                v-decorator="[
                  'enrollment[roll_no]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input a roll number!',
                      },
                    ],
                  },
                ]"
                :disabled="
                  form.getFieldValue(`enrollment[class_id]`) &&
                  form.getFieldValue(`enrollment[section_id]`)
                    ? false
                    : true
                "
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Admission Date">
              <a-date-picker
                v-decorator="[
                  'admission_date',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please input an admission date',
                      },
                    ],
                    initialValue: moment(),
                  },
                ]"
                :format="dateFormat"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Student Type">
              <a-select
                v-decorator="['student_type_id']"
                placeholder="Select student type"
              >
                <a-select-option
                  v-for="studentType in studentTypes"
                  :value="studentType.id"
                  :key="studentType.id"
                >
                  {{ studentType.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="House">
              <a-select
                v-decorator="[
                  'enrollment[house_id]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select a House!!',
                      },
                    ],
                  },
                ]"
                placeholder="Select House"
              >
                <template v-for="house in schoolHouses">
                  <a-select-option :value="house.id" :key="house.id">
                    {{ house.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Hostel">
              <a-radio-group
                v-decorator="[
                  'hostel',
                  {
                    rules: [{ required: false, message: 'Please select!' }],
                    initialValue: '0',
                  },
                ]"
              >
                <a-radio
                  v-for="option in hostellerOptions"
                  :value="option.value"
                  :key="option.value"
                  class="mr-2"
                >
                  <span class="text-bold">{{ option.name }}</span>
                </a-radio>
              </a-radio-group>
              <div v-if="form.getFieldValue('hostel') === '1'" class="mt-2">
                <a-form-item label="Provide Hostel Name">
                  <a-select
                    v-decorator="[
                      'hostel_name',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please provide hostel name!',
                          },
                        ],
                      },
                    ]"
                    placeholder="e.g.,Boys/Girls Hostel"
                  >
                    <template v-for="house in houses">
                      <a-select-option :value="house.value" :key="house.value">
                        {{ house.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-item>
              </div>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="School Bus">
              <a-radio-group
                v-decorator="[
                  'transport',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select school bus status!',
                      },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1" class="mr-2">Yes</a-radio>
                <a-radio :value="0" class="mr-2">No</a-radio>
              </a-radio-group>

              <!-- Conditional Input Field -->
              <div v-show="form.getFieldValue('transport') === 1" class="mt-2">
                <a-form-item label="Provide Pickup Point">
                  <a-input
                    v-decorator="[
                      'transport_pickup_point',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please provide pickup point!',
                          },
                        ],
                      },
                    ]"
                    placeholder="e.g.,Keishampat, Uripok etc"
                  />
                </a-form-item>
              </div>
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Daycare">
              <a-switch v-model="isDayCare" @change="onDaycareChange">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </a-form-item>
          </div>
        </div>

        <!-- Subjects -->
        <a-divider />
        <div class="row pb-3">
          <div class="col-md-4 pb-2">
            <p class="pt-3">Cumpolsory Subjects</p>
            <a-spin :spinning="sectionSpinning">
              <div
                v-for="classSubject in classSubjects.normal_subjects"
                :key="classSubject.id"
              >
                <span class="mb-2 font-weight-bold">{{
                  classSubject.name
                }}</span>
              </div>
            </a-spin>
          </div>

          <div class="col-md-8 pb-2">
            <div class="row">
              <div class="col-12">
                <p class="pt-3">Elective Subjects</p>
                <a-spin :spinning="sectionSpinning">
                  <div
                    v-for="classSubject in classSubjects.elective_subjects"
                    :key="classSubject.id"
                  >
                    <a-form-item class="d-none">
                      <a-input
                        v-decorator="[
                          `elective_subject[${classSubject.elective_subject_id}][elective_subject_id]`,
                          { initialValue: classSubject.elective_subject_id },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item
                      :label="
                        classSubject.elective_subject_name +
                        ' (' +
                        classSubject.abbreviation +
                        ')'
                      "
                      v-bind="{
                        labelCol: { span: 8 },
                        wrapperCol: { span: 16 },
                      }"
                      class="d-flex align-items-center"
                    >
                      <a-checkbox-group
                        v-decorator="[
                          `elective_subject[${classSubject.elective_subject_id}][subject_id]`,
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Select at least one subject',
                              },
                            ],
                            initialValue: [],
                          },
                        ]"
                      >
                        <a-checkbox
                          v-for="elective in classSubject.electives"
                          :key="elective.subject_id"
                          :value="elective.subject_id"
                          >{{ elective.subject_name }}
                          <strong
                            >({{ elective.abbreviation }})</strong
                          ></a-checkbox
                        >
                      </a-checkbox-group>
                    </a-form-item>
                  </div>
                </a-spin>
              </div>
              <div class="col-12" v-if="classSubjects.group_subjects">
                <p class="pt-3">Group Subjects</p>
                <a-spin :spinning="sectionSpinning">
                  <div
                    v-for="classSubject in classSubjects.group_subjects"
                    :key="classSubject.group_subject_id"
                  >
                    <span class="mb-2 font-weight-bold">{{
                      classSubject.group_subject_name
                    }}</span
                    >:
                    <span>
                      <span
                        v-for="(
                          groupSubject, index
                        ) in classSubject.group_subjects"
                        :key="groupSubject.subject_id"
                      >
                        {{ groupSubject.subject_name }}
                        {{ addCommaOnList(index, classSubject.group_subjects) }}
                      </span>
                    </span>
                  </div>
                </a-spin>
              </div>
            </div>
          </div>
        </div>

          </a-collapse-panel>

          <a-collapse-panel key="4" header="Previous Education Details">
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item label="Previous school name">
              <a-input
                placeholder="Street address"
                v-decorator="[
                  'previous_school_name',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input previous school name!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <!-- <div class="col-md-4">
            <a-form-item label="Previous class">
              <a-input
                placeholder="Course"
                v-decorator="[
                  'previous_class',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please previous course details!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div> -->

          <div class="col-md-4">
            <a-form-item label="Previous class">
              <a-select
                v-decorator="[
                  'previous_class',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select a Class!!',
                      },
                    ],
                  },
                ]"
                placeholder="Select Class"
              >
                <template v-for="classes in previousClasses">
                  <a-select-option :value="classes.value" :key="classes.value">
                    {{ classes.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Previous Board">
              <a-input
                placeholder="Board"
                v-decorator="[
                  'previous_board',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input previous board!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Prevous %">
              <a-input
                placeholder="Score %"
                v-decorator="[
                  'previous_percentage',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please input previous score!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Previous Roll No">
              <a-input
                placeholder="Roll No"
                v-decorator="['previous_rollno']"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="Previous Total Mark">
              <a-input
                placeholder="Total Mark"
                v-decorator="['previous_mark']"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Previous CGPA">
              <a-input placeholder="CGPA" v-decorator="['previous_cgpa']" />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="No of days attended">
              <a-input
                placeholder="Days attended"
                v-decorator="['days_attended']"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Previous Exam Type">
              <a-checkbox-group
                v-decorator="[
                  'previous_exam_type', // This will now hold an array, e.g., ['hslc'] or ['other']
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select exam type!',
                      },
                      // Custom validator to ensure only one checkbox is selected
                      {
                        validator: validateSingleCheckbox, // New validator method
                      },
                    ],
                    initialValue: [], // Important: initialValue for checkbox-group must be an array
                  },
                ]"
                @change="handleCheckboxChange"
              >
                <a-checkbox value="hslc" class="mr-2">HSLC</a-checkbox>
                <a-checkbox value="aisse" class="mr-2">AISSE</a-checkbox>
                <a-checkbox value="other" class="mr-2">Other</a-checkbox>
              </a-checkbox-group>

              <div v-if="showOtherExamTypeField" class="mt-2">
                <a-form-item label="Specify Exam Name">
                  <a-input
                    v-decorator="[
                      'previous_exam_other',
                      {
                        rules: [
                          {
                            required: false, // Make required only when visible
                            message: 'Please specify exam name!',
                          },
                        ],
                      },
                    ]"
                    placeholder="Enter exam name"
                  />
                </a-form-item>
              </div>
            </a-form-item>
          </div>
        </div>

        <!-- <a-divider />
        <p class="neo_form_sub_heading pt-3">Sibling Information</p>
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item
              label="Has Siblings?"
            >
              <a-radio-group
                  v-decorator="[
                    'has_sibling',
                    {rules: [{ required: true, message: 'This value is required' }],  initialValue: 0 },
                  ]"
                >
                  <a-radio :value="1">Yes</a-radio>
                  <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <div class="col-md-4" v-if="form.getFieldValue('has_sibling')">
            <a-form-item label="Siblings">
              <a-select
                placeholder="Add Siblings"
                v-decorator="['sibling_id', {rules: [{ required: form.getFieldValue('has_sibling') ? true : false, message: 'Please add atleast one sibling!' }], initialValue: selectedSiblings }]"
                mode="multiple"
                labelInValue
                style="width: 100%"
                :filterOption="false"
                @search="fetchSiblings"
                @change="handleSiblingsChange"
                :notFoundContent="fetching ? undefined : null"
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <template v-for="student in siblingsData">
                  <a-select-option :key="student.id" :value="student.id">{{student.first_name}} {{student.last_name}}</a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>

        </div> -->

          </a-collapse-panel>

          <a-collapse-panel key="5" header="Parents Information">
            <a-collapse v-model="subActiveKey" :bordered="false" :destroyInactivePanel="false" class="sub-collapse">
              <a-collapse-panel key="father" header="Father's Information">
                <template v-if="!form.getFieldValue('has_sibling')">
                  <div class="row pb-3">
                    <div class="col-md-4">
                      <a-form-item label="Suffix">
                        <a-select
                          v-decorator="[
                            'father[suffix]',
                            {
                              rules: [
                                { required: false, message: 'A suffix is required!' },
                              ],
                              initialValue: 'Mr',
                            },
                          ]"
                        >
                          <a-select-option
                            v-for="nameSuffix in nameSuffixes"
                            :value="nameSuffix.value"
                            :key="nameSuffix.value"
                          >
                            {{ nameSuffix.name }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </div>
                    <div class="col-md-4">
                      <a-form-item label="First name">
                        <a-input
                          placeholder="First name"
                          v-decorator="[
                            'father[first_name]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: `Please father's first name!`,
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </div>
                    <div class="col-md-4">
                      <a-form-item label="Last name">
                        <a-input
                          placeholder="Last name"
                          v-decorator="[
                            'father[last_name]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: `Please father's last name!`,
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </div>

                    <div class="col-md-6">
                      <a-form-item label="Qualification">
                        <a-radio-group
                          v-decorator="[
                            'father[qualification]',
                            {
                              rules: [
                                { required: false, message: 'This value is required' },
                              ],
                              initialValue: 'GD',
                            },
                          ]"
                        >
                          <template v-for="qualification in qualifications">
                            <a-radio
                              :value="qualification.value"
                              :key="qualification.value"
                              >{{ qualification.name }}</a-radio
                            >
                          </template>
                        </a-radio-group>
                      </a-form-item>
                    </div>
                    <div class="col-md-6">
                      <a-form-item label="Occupation">
                        <a-radio-group
                          v-decorator="[
                            'father[occupation]',
                            {
                              rules: [
                                { required: false, message: 'This value is required' },
                              ],
                              initialValue: 'UN',
                            },
                          ]"
                        >
                          <template v-for="occupation in occupations">
                            <a-radio
                              :value="occupation.value"
                              :key="occupation.value"
                              >{{ occupation.name }}</a-radio
                            >
                          </template>
                        </a-radio-group>
                      </a-form-item>
                    </div>

                    <div class="col-md-6">
                      <a-form-item label="Office Address">
                        <a-input
                          placeholder="Office address"
                          v-decorator="[
                            'father[office_address]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: `Please father's office address!`,
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </div>
                    <div class="col-md-4">
                      <a-form-item label="Annual income">
                        <div style="width: 250px">
                          <a-input-number
                            placeholder="Income"
                            v-decorator="[
                              'father[income]',
                              {
                                rules: [
                                  {
                                    required: false,
                                    message: `Please father's annual income!`,
                                  },
                                ],
                              },
                            ]"
                            :initialValue="100000"
                            :min="0"
                            :formatter="
                              (value) =>
                                `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            "
                            :parser="(value) => value.replace(/\₹\s?|(,*)/g, '')"
                            style="width: 100%"
                          />
                        </div>
                      </a-form-item>
                    </div>

                    <div class="col-md-4">
                      <a-form-item label="ID type">
                        <a-select
                          v-decorator="[
                            'father[id_type]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: 'Please select an ID type!!',
                                },
                              ],
                              initialValue: undefined,
                            },
                          ]"
                          placeholder="Select ID type"
                        >
                          <a-select-option :value="undefined"> None </a-select-option>
                          <a-select-option
                            v-for="idType in idTypes"
                            :value="idType.value"
                            :key="idType.value"
                          >
                            {{ idType.name }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </div>

                    <div class="col-md-4">
                      <a-form-item label="ID number">
                        <a-input
                          placeholder="ID number"
                          v-decorator="[
                            'father[id_number]',
                            {
                              rules: [
                                {
                                  required: !!form.getFieldValue('father[id_type]'),
                                  message: `Please input father's id number!`,
                                },
                              ],
                            },
                          ]"
                          :disabled="!form.getFieldValue('father[id_type]')"
                        />
                      </a-form-item>
                    </div>
                  </div>
                  <!-- Address Select -->
                    <a-collapse v-model="subActiveKey" :bordered="false">
                      <a-collapse-panel key="fatherAddress" header="Address & Contact Details">
                        <div class="row">
                          <div class="col-md-6 d-none">
                            <a-form-item label="Father's contact address is">
                              <a-radio-group
                                v-decorator="[
                                  'father_contact_same_as_student',
                                  {
                                    rules: [
                                      { required: false, message: 'This value is required' },
                                    ],
                                    initialValue: false,
                                  },
                                ]"
                              >
                                <a-radio :value="true">Same as student</a-radio>
                                <a-radio :value="false">Different from student</a-radio>
                              </a-radio-group>
                            </a-form-item>
                          </div>
                        </div>
                        <!-- father's contact -->
                        <div class="row pb-3">
                          <div class="col-md-9">
                            <a-form-item label="Address">
                              <a-input
                                placeholder="Street address"
                                v-decorator="[
                                  'father[contact][address]',
                                  {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Please input school address!',
                                      },
                                    ],
                                    initialValue: form.getFieldValue(
                                      'father_contact_same_as_student'
                                    )
                                      ? form.getFieldValue('student[contact][address]')
                                      : '',
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="City">
                              <a-input
                                placeholder="City"
                                v-decorator="[
                                  'father[contact][city]',
                                  {
                                    rules: [
                                      { required: false, message: 'Please input city!' },
                                    ],
                                    initialValue: form.getFieldValue(
                                      'father_contact_same_as_student'
                                    )
                                      ? form.getFieldValue('student[contact][city]')
                                      : '',
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="District">
                              <a-input
                                placeholder="District"
                                v-decorator="[
                                  'father[contact][district]',
                                  {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Please input a district!',
                                      },
                                    ],
                                    initialValue: form.getFieldValue(
                                      'father_contact_same_as_student'
                                    )
                                      ? form.getFieldValue('student[contact][district]')
                                      : '',
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="Landmark">
                              <a-input
                                placeholder="Landmark"
                                v-decorator="[
                                  'father[contact][landmark]',
                                  {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Please input a landmark!',
                                      },
                                    ],
                                    initialValue: form.getFieldValue(
                                      'father_contact_same_as_student'
                                    )
                                      ? form.getFieldValue('student[contact][landmark]')
                                      : '',
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="Pincode">
                              <a-input
                                placeholder="Pincode"
                                v-decorator="[
                                  'father[contact][pincode]',
                                  {
                                    rules: [
                                      { required: false, message: 'Please input a pincode!' },
                                    ],
                                    initialValue: form.getFieldValue(
                                      'father_contact_same_as_student'
                                    )
                                      ? form.getFieldValue('student[contact][pincode]')
                                      : '',
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="State">
                              <a-input
                                placeholder="State"
                                v-decorator="[
                                  'father[contact][state]',
                                  {
                                    rules: [
                                      { required: false, message: 'Please input a state!' },
                                    ],
                                    initialValue: form.getFieldValue(
                                      'father_contact_same_as_student'
                                    )
                                      ? form.getFieldValue('student[contact][state]')
                                      : '',
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="Country">
                              <a-input
                                placeholder="Country"
                                v-decorator="[
                                  'father[contact][country]',
                                  {
                                    rules: [
                                      { required: false, message: 'Please input a country!' },
                                    ],
                                    initialValue: form.getFieldValue(
                                      'father_contact_same_as_student'
                                    )
                                      ? form.getFieldValue('student[contact][country]')
                                      : '',
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>
                          <div class="col-md-3">
                            <a-form-item label="Phone">
                              <a-input
                                placeholder="Phone"
                                v-decorator="[
                                  'father[contact][phone]',
                                  {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Please input a valid phone!',
                                        pattern: new RegExp(`^[0-9]{7,14}$`),
                                      },
                                    ],
                                  },
                                ]"
                                width="100%"
                              >
                                <a-select
                                  slot="addonBefore"
                                  v-decorator="[
                                    'father[contact][country_code]',
                                    { initialValue: '91' },
                                  ]"
                                  style="width: 70px"
                                >
                                  <a-select-option
                                    v-for="countryCode in countryCodes"
                                    :value="countryCode.value"
                                    :key="countryCode.value"
                                  >
                                    <span class="text-bold">{{ countryCode.name }}</span>
                                  </a-select-option>
                                </a-select>
                              </a-input>
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="Alt. Phone">
                              <a-input
                                placeholder="Alt. Phone"
                                v-decorator="[
                                  'father[contact][alt_phone]',
                                  {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Please input an valid alt phone!',
                                        pattern: new RegExp(`^[0-9]{7,14}$`),
                                      },
                                    ],
                                  },
                                ]"
                                width="100%"
                              >
                                <a-select
                                  slot="addonBefore"
                                  v-decorator="[
                                    'father[contact][alt_country_code]',
                                    { initialValue: '91' },
                                  ]"
                                  style="width: 70px"
                                >
                                  <a-select-option
                                    v-for="countryCode in countryCodes"
                                    :value="countryCode.value"
                                    :key="countryCode.value"
                                  >
                                    <span class="text-bold">{{ countryCode.name }}</span>
                                  </a-select-option>
                                </a-select>
                              </a-input>
                            </a-form-item>
                          </div>

                          <div class="col-md-3">
                            <a-form-item label="Email">
                              <a-input
                                placeholder="Email"
                                v-decorator="[
                                  'father[contact][email]',
                                  {
                                    rules: [
                                      {
                                        type: 'email',
                                        message: 'The input is not valid email!',
                                      },
                                      {
                                        required: false,
                                        message: 'Please input an email!',
                                      },
                                    ],
                                  },
                                ]"
                              />
                            </a-form-item>
                          </div>
                        </div>
                      </a-collapse-panel>
                    </a-collapse>
                  </template>
                <template v-else>
                  <div class="mb-3">
                    <a-tag color="blue"
                      >Father's information will be copied from sibling!</a-tag
                    >
                  </div>
                </template>
              </a-collapse-panel>

              <a-collapse-panel key="mother" header="Mother's Information">
                <template v-if="!form.getFieldValue('has_sibling')">
                  <div class="row pb-3">
                    <div class="col-md-4">
                      <a-form-item label="Suffix">
                        <a-select
                          v-decorator="[
                            'mother[suffix]',
                            {
                              rules: [
                                { required: false, message: 'A suffix is required!' },
                              ],
                              initialValue: 'Mrs',
                            },
                          ]"
                        >
                          <a-select-option
                            v-for="nameSuffix in nameSuffixes"
                            :value="nameSuffix.value"
                            :key="nameSuffix.value"
                          >
                            {{ nameSuffix.name }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </div>
                    <div class="col-md-4">
                      <a-form-item label="First name">
                        <a-input
                          placeholder="First name"
                          v-decorator="[
                            'mother[first_name]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: `Please mother's first name!`,
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </div>
                    <div class="col-md-4">
                      <a-form-item label="Last name">
                        <a-input
                          placeholder="Last name"
                          v-decorator="[
                            'mother[last_name]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: `Please mother's last name!`,
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </div>

                    <div class="col-md-6">
                      <a-form-item label="Qualification">
                        <a-radio-group
                          v-decorator="[
                            'mother[qualification]',
                            {
                              rules: [
                                { required: false, message: 'This value is required' },
                              ],
                              initialValue: 'GD',
                            },
                          ]"
                        >
                          <template v-for="qualification in qualifications">
                            <a-radio
                              :value="qualification.value"
                              :key="qualification.value"
                              >{{ qualification.name }}</a-radio
                            >
                          </template>
                        </a-radio-group>
                      </a-form-item>
                    </div>
                    <div class="col-md-6">
                      <a-form-item label="Occupation">
                        <a-radio-group
                          v-decorator="[
                            'mother[occupation]',
                            {
                              rules: [
                                { required: false, message: 'This value is required' },
                              ],
                              initialValue: 'UN',
                            },
                          ]"
                        >
                          <template v-for="occupation in occupations">
                            <a-radio
                              :value="occupation.value"
                              :key="occupation.value"
                              >{{ occupation.name }}</a-radio
                            >
                          </template>
                        </a-radio-group>
                      </a-form-item>
                    </div>

                    <div class="col-md-6">
                      <a-form-item label="Office Address">
                        <a-input
                          placeholder="Office address"
                          v-decorator="[
                            'mother[office_address]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: `Please mother's office address!`,
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </div>
                    <div class="col-md-4">
                      <a-form-item label="Annual income">
                        <div style="width: 250px">
                          <a-input-number
                            placeholder="Income"
                            v-decorator="[
                              'mother[income]',
                              {
                                rules: [
                                  {
                                    required: false,
                                    message: `Please mother's annual income!`,
                                  },
                                ],
                              },
                            ]"
                            :initialValue="100000"
                            :min="0"
                            :formatter="
                              (value) =>
                                `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            "
                            :parser="(value) => value.replace(/\₹\s?|(,*)/g, '')"
                            style="width: 100%"
                          />
                        </div>
                      </a-form-item>
                    </div>

                    <div class="col-md-4">
                      <a-form-item label="ID type">
                        <a-select
                          v-decorator="[
                            'mother[id_type]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: 'Please select an ID type!!',
                                },
                              ],
                              initialValue: undefined,
                            },
                          ]"
                          placeholder="Select ID type"
                        >
                          <a-select-option :value="undefined"> None </a-select-option>
                          <a-select-option
                            v-for="idType in idTypes"
                            :value="idType.value"
                            :key="idType.value"
                          >
                            {{ idType.name }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </div>

                    <div class="col-md-4">
                      <a-form-item label="ID number">
                        <a-input
                          placeholder="ID number"
                          v-decorator="[
                            'mother[id_number]',
                            {
                              rules: [
                                {
                                  required: !!form.getFieldValue('mother[id_type]'),
                                  message: `Please input mother's id number!`,
                                },
                              ],
                            },
                          ]"
                          :disabled="!form.getFieldValue('mother[id_type]')"
                        />
                      </a-form-item>
                    </div>
                  </div>
                  <!-- Address Select -->
                      <a-collapse v-model="subActiveKey" :bordered="false">
                        <a-collapse-panel key="motherAddress" header="Address & Contact Details">
                          <div class="row">
                            <div class="col-md-6 d-none">
                              <a-form-item label="Mother's contact address is">
                                <a-radio-group
                                  v-decorator="[
                                    'mother_contact_same_as',
                                    {
                                      rules: [
                                        { required: false, message: 'This value is required' },
                                      ],
                                      initialValue: 'different',
                                    },
                                  ]"
                                >
                                  <a-radio value="student">Same as student</a-radio>
                                  <a-radio value="father">Same as father</a-radio>
                                  <a-radio value="different">Different</a-radio>
                                </a-radio-group>
                              </a-form-item>
                            </div>
                          </div>
                          <!-- mother's contact -->
                          <div class="row pb-3">
                            <div class="col-md-9">
                              <a-form-item label="Address">
                                <a-input
                                  placeholder="Street address"
                                  v-decorator="[
                                    'mother[contact][address]',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Please input school address!',
                                        },
                                      ],
                                      initialValue:
                                        form.getFieldValue('mother_contact_same_as') ===
                                        'student'
                                          ? form.getFieldValue('student[contact][address]')
                                          : form.getFieldValue('mother_contact_same_as') ===
                                            'father'
                                          ? form.getFieldValue('father[contact][address]')
                                          : '',
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="City">
                                <a-input
                                  placeholder="City"
                                  v-decorator="[
                                    'mother[contact][city]',
                                    {
                                      rules: [
                                        { required: false, message: 'Please input city!' },
                                      ],
                                      initialValue:
                                        form.getFieldValue('mother_contact_same_as') ===
                                        'student'
                                          ? form.getFieldValue('student[contact][city]')
                                          : form.getFieldValue('mother_contact_same_as') ===
                                            'father'
                                          ? form.getFieldValue('father[contact][city]')
                                          : '',
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="District">
                                <a-input
                                  placeholder="District"
                                  v-decorator="[
                                    'mother[contact][district]',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Please input a district!',
                                        },
                                      ],
                                      initialValue:
                                        form.getFieldValue('mother_contact_same_as') ===
                                        'student'
                                          ? form.getFieldValue('student[contact][district]')
                                          : form.getFieldValue('mother_contact_same_as') ===
                                            'father'
                                          ? form.getFieldValue('father[contact][district]')
                                          : '',
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="Landmark">
                                <a-input
                                  placeholder="Landmark"
                                  v-decorator="[
                                    'mother[contact][landmark]',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Please input a landmark!',
                                        },
                                      ],
                                      initialValue:
                                        form.getFieldValue('mother_contact_same_as') ===
                                        'student'
                                          ? form.getFieldValue('student[contact][landmark]')
                                          : form.getFieldValue('mother_contact_same_as') ===
                                            'father'
                                          ? form.getFieldValue('father[contact][landmark]')
                                          : '',
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="Pincode">
                                <a-input
                                  placeholder="Pincode"
                                  v-decorator="[
                                    'mother[contact][pincode]',
                                    {
                                      rules: [
                                        { required: false, message: 'Please input a pincode!' },
                                      ],
                                      initialValue:
                                        form.getFieldValue('mother_contact_same_as') ===
                                        'student'
                                          ? form.getFieldValue('student[contact][pincode]')
                                          : form.getFieldValue('mother_contact_same_as') ===
                                            'father'
                                          ? form.getFieldValue('father[contact][pincode]')
                                          : '',
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="State">
                                <a-input
                                  placeholder="State"
                                  v-decorator="[
                                    'mother[contact][state]',
                                    {
                                      rules: [
                                        { required: false, message: 'Please input a state!' },
                                      ],
                                      initialValue:
                                        form.getFieldValue('mother_contact_same_as') ===
                                        'student'
                                          ? form.getFieldValue('student[contact][state]')
                                          : form.getFieldValue('mother_contact_same_as') ===
                                            'father'
                                          ? form.getFieldValue('father[contact][state]')
                                          : '',
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="Country">
                                <a-input
                                  placeholder="Country"
                                  v-decorator="[
                                    'mother[contact][country]',
                                    {
                                      rules: [
                                        { required: false, message: 'Please input a country!' },
                                      ],
                                      initialValue:
                                        form.getFieldValue('mother_contact_same_as') ===
                                        'student'
                                          ? form.getFieldValue('student[contact][country]')
                                          : form.getFieldValue('mother_contact_same_as') ===
                                            'father'
                                          ? form.getFieldValue('father[contact][country]')
                                          : '',
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>
                            <div class="col-md-3">
                              <a-form-item label="Phone">
                                <a-input
                                  placeholder="Phone"
                                  v-decorator="[
                                    'mother[contact][phone]',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Please input a valid phone!',
                                          pattern: new RegExp(`^[0-9]{7,14}$`),
                                        },
                                      ],
                                    },
                                  ]"
                                  width="100%"
                                >
                                  <a-select
                                    slot="addonBefore"
                                    v-decorator="[
                                      'mother[contact][country_code]',
                                      { initialValue: '91' },
                                    ]"
                                    style="width: 70px"
                                  >
                                    <a-select-option
                                      v-for="countryCode in countryCodes"
                                      :value="countryCode.value"
                                      :key="countryCode.value"
                                    >
                                      <span class="text-bold">{{ countryCode.name }}</span>
                                    </a-select-option>
                                  </a-select>
                                </a-input>
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="Alt. Phone">
                                <a-input
                                  placeholder="Alt. Phone"
                                  v-decorator="[
                                    'mother[contact][alt_phone]',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Please input an valid alt phone!',
                                          pattern: new RegExp(`^[0-9]{7,14}$`),
                                        },
                                      ],
                                    },
                                  ]"
                                  width="100%"
                                >
                                  <a-select
                                    slot="addonBefore"
                                    v-decorator="[
                                      'mother[contact][alt_country_code]',
                                      { initialValue: '91' },
                                    ]"
                                    style="width: 70px"
                                  >
                                    <a-select-option
                                      v-for="countryCode in countryCodes"
                                      :value="countryCode.value"
                                      :key="countryCode.value"
                                    >
                                      <span class="text-bold">{{ countryCode.name }}</span>
                                    </a-select-option>
                                  </a-select>
                                </a-input>
                              </a-form-item>
                            </div>

                            <div class="col-md-3">
                              <a-form-item label="Email">
                                <a-input
                                  placeholder="Email"
                                  v-decorator="[
                                    'mother[contact][email]',
                                    {
                                      rules: [
                                        {
                                          type: 'email',
                                          message: 'The input is not valid email!',
                                        },
                                        {
                                          required: false,
                                          message: 'Please input an email!',
                                        },
                                      ],
                                    },
                                  ]"
                                />
                              </a-form-item>
                            </div>
                          </div>
                        </a-collapse-panel>
                      </a-collapse>
                    </template>
                <template v-else>
                  <div class="mb-3">
                    <a-tag color="blue"
                      >Mother's information will be copied from sibling!</a-tag
                    >
                  </div>
                </template>
              </a-collapse-panel>

              <a-collapse-panel key="guardian" header="Guardian's Information">
                <div class="row pb-3">
                  <div class="col-md-4">
                    <a-form-item label="Suffix">
                      <a-select
                        v-decorator="[
                          'guardian[suffix]',
                          {
                            rules: [
                              { required: false, message: 'A suffix is required!' },
                            ],
                            initialValue: undefined,
                          },
                        ]"
                        placeholder="Select suffix"
                      >
                        <a-select-option :value="undefined">
                          Select suffix
                        </a-select-option>
                        <a-select-option
                          v-for="nameSuffix in nameSuffixes"
                          :value="nameSuffix.value"
                          :key="nameSuffix.value"
                        >
                          {{ nameSuffix.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item label="First name">
                      <a-input
                        placeholder="First name"
                        v-decorator="[
                          'guardian[first_name]',
                          {
                            rules: [
                              {
                                required: false,
                                message: `Please input guardian's first name!`,
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item label="Last name">
                      <a-input
                        placeholder="Last name"
                        v-decorator="[
                          'guardian[last_name]',
                          {
                            rules: [
                              {
                                required: false,
                                message: `Please input guardian's last name!`,
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item label="Qualification">
                      <a-radio-group
                        v-decorator="[
                          'guardian[qualification]',
                          {
                            rules: [
                              {
                                required: false,
                                message: 'This value is required',
                              },
                            ],
                            initialValue: 'GD',
                          },
                        ]"
                      >
                        <template v-for="qualification in qualifications">
                          <a-radio
                            :value="qualification.value"
                            :key="qualification.value"
                            >{{ qualification.name }}</a-radio
                          >
                        </template>
                      </a-radio-group>
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item label="Occupation">
                      <a-radio-group
                        v-decorator="[
                          'guardian[occupation]',
                          {
                            rules: [
                              {
                                required: false,
                                message: 'This value is required',
                              },
                            ],
                            initialValue: 'UN',
                          },
                        ]"
                      >
                        <template v-for="occupation in occupations">
                          <a-radio
                            :value="occupation.value"
                            :key="occupation.value"
                            >{{ occupation.name }}</a-radio
                          >
                        </template>
                      </a-radio-group>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item label="Office Address">
                      <a-input
                        placeholder="Office address"
                        v-decorator="[
                          'guardian[office_address]',
                          {
                            rules: [
                              {
                                required: false,
                                message: `Please guardian's office address!`,
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item label="Annual income">
                      <div style="width: 250px">
                        <a-input-number
                          placeholder="Income"
                          v-decorator="[
                            'guardian[income]',
                            {
                              rules: [
                                {
                                  required: false,
                                  message: `Please guardian's annual income!`,
                                },
                              ],
                            },
                          ]"
                          :initialValue="100000"
                          :min="0"
                          :formatter="
                            (value) =>
                              `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          "
                          :parser="(value) => value.replace(/\₹\s?|(,*)/g, '')"
                          style="width: 100%"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-4">
                    <a-form-item label="ID type">
                      <a-select
                        v-decorator="[
                          'guardian[id_type]',
                          {
                            rules: [
                              {
                                required: false,
                                message: 'Please select an ID type!!',
                              },
                            ],
                            initialValue: undefined,
                          },
                        ]"
                        placeholder="Select ID type"
                      >
                        <a-select-option :value="undefined"> None </a-select-option>
                        <a-select-option
                          v-for="idType in idTypes"
                          :value="idType.value"
                          :key="idType.value"
                        >
                          {{ idType.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>

                  <div class="col-md-4">
                    <a-form-item label="ID number">
                      <a-input
                        placeholder="ID number"
                        v-decorator="[
                          'guardian[id_number]',
                          {
                            rules: [
                              {
                                required: !!form.getFieldValue('guardian[id_type]'),
                                message: `Please input guardian's id number!`,
                              },
                            ],
                          },
                        ]"
                        :disabled="!form.getFieldValue('guardian[id_type]')"
                      />
                    </a-form-item>
                  </div>

                  <div class="col-md-4">
                    <a-form-item label="Gender">
                      <a-radio-group
                        v-decorator="[
                          'guardian[gender]',
                          {
                            rules: [
                              {
                                required: false,
                                message: 'Please select a gender!',
                              },
                            ],
                            initialValue: 'M',
                          },
                        ]"
                      >
                        <a-radio
                          v-for="genderType in genderTypes"
                          :value="genderType.value"
                          :key="genderType.value"
                          class="mr-2"
                        >
                          <span class="text-bold">{{ genderType.name }}</span>
                        </a-radio>
                      </a-radio-group>
                    </a-form-item>
                  </div>

                  <div class="col-md-4">
                    <a-form-item label="Relation with student">
                      <a-input
                        placeholder="Relation"
                        v-decorator="[
                          'guardian[guardian_relation]',
                          {
                            rules: [
                              {
                                required: false,
                                message: `Please input guardian's id number!`,
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
                <!-- Address Select -->
                  <a-collapse v-model="subActiveKey" :bordered="false">
                    <a-collapse-panel key="guardianAddress" header="Address & Contact Details">
                      <div class="row">
                        <div class="col-md-12 d-none">
                          <a-form-item label="Guardian's contact address is">
                            <a-radio-group
                              v-decorator="[
                                'guardian_contact_same_as',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'This value is required',
                                    },
                                  ],
                                  initialValue: 'different',
                                },
                              ]"
                            >
                              <a-radio value="student">Same as student</a-radio>
                              <a-radio
                                value="father"
                                v-if="
                                  !form.getFieldValue(
                                    'father_contact_same_as_student'
                                  )
                                "
                                >Same as father</a-radio
                              >
                              <a-radio value="mother">Same as mother</a-radio>
                              <a-radio value="different">Different</a-radio>
                            </a-radio-group>
                          </a-form-item>
                        </div>
                      </div>
                      <!-- guardian's contact -->
                      <div class="row pb-3">
                        <div class="col-md-8">
                          <a-form-item label="Address">
                            <a-input
                              placeholder="Street address"
                              v-decorator="[
                                'guardian[contact][address]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input school address!',
                                    },
                                  ],
                                  initialValue:
                                    form.getFieldValue('guardian_contact_same_as') ===
                                    'student'
                                      ? form.getFieldValue('student[contact][address]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'father'
                                      ? form.getFieldValue('father[contact][address]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'mother'
                                      ? form.getFieldValue('mother[contact][address]')
                                      : '',
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="City">
                            <a-input
                              placeholder="City"
                              v-decorator="[
                                'guardian[contact][city]',
                                {
                                  rules: [
                                    { required: false, message: 'Please input city!' },
                                  ],
                                  initialValue:
                                    form.getFieldValue('guardian_contact_same_as') ===
                                    'student'
                                      ? form.getFieldValue('student[contact][city]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'father'
                                      ? form.getFieldValue('father[contact][city]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'mother'
                                      ? form.getFieldValue('mother[contact][city]')
                                      : '',
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="District">
                            <a-input
                              placeholder="District"
                              v-decorator="[
                                'guardian[contact][district]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input a district!',
                                    },
                                  ],
                                  initialValue:
                                    form.getFieldValue('guardian_contact_same_as') ===
                                    'student'
                                      ? form.getFieldValue('student[contact][district]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'father'
                                      ? form.getFieldValue('father[contact][district]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'mother'
                                      ? form.getFieldValue('mother[contact][district]')
                                      : '',
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="Landmark">
                            <a-input
                              placeholder="Landmark"
                              v-decorator="[
                                'guardian[contact][landmark]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input a landmark!',
                                    },
                                  ],
                                  initialValue:
                                    form.getFieldValue('guardian_contact_same_as') ===
                                    'student'
                                      ? form.getFieldValue('student[contact][landmark]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'father'
                                      ? form.getFieldValue('father[contact][landmark]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'mother'
                                      ? form.getFieldValue('mother[contact][landmark]')
                                      : '',
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="Pincode">
                            <a-input
                              placeholder="Pincode"
                              v-decorator="[
                                'guardian[contact][pincode]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input a pincode!',
                                    },
                                  ],
                                  initialValue:
                                    form.getFieldValue('guardian_contact_same_as') ===
                                    'student'
                                      ? form.getFieldValue('student[contact][pincode]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'father'
                                      ? form.getFieldValue('father[contact][pincode]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'mother'
                                      ? form.getFieldValue('mother[contact][pincode]')
                                      : '',
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="State">
                            <a-input
                              placeholder="State"
                              v-decorator="[
                                'guardian[contact][state]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input a state!',
                                    },
                                  ],
                                  initialValue:
                                    form.getFieldValue('guardian_contact_same_as') ===
                                    'student'
                                      ? form.getFieldValue('student[contact][state]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'father'
                                      ? form.getFieldValue('father[contact][state]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'mother'
                                      ? form.getFieldValue('mother[contact][state]')
                                      : '',
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="Country">
                            <a-input
                              placeholder="Country"
                              v-decorator="[
                                'guardian[contact][country]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input a country!',
                                    },
                                  ],
                                  initialValue:
                                    form.getFieldValue('guardian_contact_same_as') ===
                                    'student'
                                      ? form.getFieldValue('student[contact][country]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'father'
                                      ? form.getFieldValue('father[contact][country]')
                                      : form.getFieldValue(
                                          'guardian_contact_same_as'
                                        ) === 'mother'
                                      ? form.getFieldValue('mother[contact][country]')
                                      : '',
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>
                        <div class="col-md-4">
                          <a-form-item label="Phone">
                            <a-input
                              placeholder="Phone"
                              v-decorator="[
                                'guardian[contact][phone]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input a valid phone!',
                                      pattern: new RegExp(`^[0-9]{7,14}$`),
                                    },
                                  ],
                                },
                              ]"
                              width="100%"
                            >
                              <a-select
                                slot="addonBefore"
                                v-decorator="[
                                  'guardian[contact][country_code]',
                                  { initialValue: '91' },
                                ]"
                                style="width: 70px"
                              >
                                <a-select-option
                                  v-for="countryCode in countryCodes"
                                  :value="countryCode.value"
                                  :key="countryCode.value"
                                >
                                  <span class="text-bold">{{ countryCode.name }}</span>
                                </a-select-option>
                              </a-select>
                            </a-input>
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="Alt. Phone">
                            <a-input
                              placeholder="Alt. Phone"
                              v-decorator="[
                                'guardian[contact][alt_phone]',
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input an valid alt phone!',
                                      pattern: new RegExp(`^[0-9]{7,14}$`),
                                    },
                                  ],
                                },
                              ]"
                              width="100%"
                            >
                              <a-select
                                slot="addonBefore"
                                v-decorator="[
                                  'guardian[contact][alt_country_code]',
                                  { initialValue: '91' },
                                ]"
                                style="width: 70px"
                              >
                                <a-select-option
                                  v-for="countryCode in countryCodes"
                                  :value="countryCode.value"
                                  :key="countryCode.value"
                                >
                                  <span class="text-bold">{{ countryCode.name }}</span>
                                </a-select-option>
                              </a-select>
                            </a-input>
                          </a-form-item>
                        </div>

                        <div class="col-md-4">
                          <a-form-item label="Email">
                            <a-input
                              placeholder="Email"
                              v-decorator="[
                                'guardian[contact][email]',
                                {
                                  rules: [
                                    {
                                      type: 'email',
                                      message: 'The input is not valid email!',
                                    },
                                    {
                                      required: false,
                                      message: 'Please input an email!',
                                    },
                                  ],
                                },
                              ]"
                            />
                          </a-form-item>
                        </div>
                      </div>
                    </a-collapse-panel>
                  </a-collapse>
              </a-collapse-panel>
            </a-collapse>
          </a-collapse-panel>

          <a-collapse-panel key="6" header="Medical Information">
        <div class="row pb-3">
          <div class="col-md-4">
            <a-form-item label="Blood group">
              <a-select
                v-decorator="[
                  'blood_group',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select a blood group!',
                      },
                    ],
                    initialValue: undefined,
                  },
                ]"
                placeholder="Select a blood group"
              >
                <a-select-option :value="undefined">
                  Select a blood group
                </a-select-option>
                <a-select-option
                  v-for="bloodGroup in bloodGroups"
                  :value="bloodGroup.value"
                  :key="bloodGroup.value"
                >
                  {{ bloodGroup.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-8">
            <a-form-item label="Allergies">
              <a-input
                placeholder="Allergies"
                v-decorator="[
                  'allergies',
                  {
                    rules: [
                      { required: false, message: `Please add an allergy!` },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Height">
              <a-input
                placeholder="Height"
                v-decorator="[
                  'height',
                  {
                    rules: [
                      {
                        required: false,
                        message: `Please input student's height!`,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="col-md-4">
            <a-form-item label="Weight">
              <a-input
                placeholder="Weight"
                v-decorator="[
                  'weight',
                  {
                    rules: [
                      {
                        required: false,
                        message: `Please input student's weight!`,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <a-form-item label="Has the child suffered from any major illness?">
              <a-radio-group
                v-decorator="[
                  'has_major_illness',
                  {
                    rules: [
                      { required: false, message: 'Please select an option!' },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="0">No</a-radio>
                <a-radio :value="1">Yes</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item label="Type of illness">
              <a-input
                placeholder="Illness description"
                v-decorator="[
                  'major_illness',
                  {
                    rules: [
                      {
                        required: form.getFieldValue('has_major_illness')
                          ? true
                          : false,
                        message: `Please input major illness details!`,
                      },
                    ],
                  },
                ]"
                :disabled="!form.getFieldValue('has_major_illness')"
              />
            </a-form-item>
          </div>
        </div>

        <a-divider />
        <p class="neo_form_sub_heading pt-2 mb-0">
          Additional Medical Information
        </p>
        <div class="row justify-content-start py-3">
          <div class="col text-md-right">
            <medical-history-list :studentData="studentData" />
          </div>
        </div>
          </a-collapse-panel>

          <a-collapse-panel key="7" header="Other Informations">
        <div class="row pb-3">
          <div class="col-md-3">
            <a-form-item label="Sports">
              <a-radio-group
                v-decorator="[
                  'student[meta][sports]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select an option!',
                      },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Orphan">
              <a-radio-group
                v-decorator="[
                  'student[meta][orphaned]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select an option!',
                      },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Internal Displaced Person(IDP)">
              <a-radio-group
                v-decorator="[
                  'student[meta][idp]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select an option!',
                      },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-3">
            <a-form-item label="Tattoo on any visible part of body">
              <a-radio-group
                v-decorator="[
                  'student[meta][tattooed]',
                  {
                    rules: [
                      {
                        required: false,
                        message: 'Please select an option!',
                      },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </div>
          </a-collapse-panel>

          <a-collapse-panel key="8" header="Upload Documents">
        <div class="row pb-3">
          <div class="col-md-3">
            <a-form-item label="Student Photo">
              <div v-if="photo" class="mb-2">
                <img
                  :src="photo"
                  alt="student photo"
                  class="img-fluid border rounded p-1"
                  style="max-height: 150px; object-fit: cover;"
                />
                <div class="mt-1">
                  <a-button size="small" type="danger" ghost @click="handleRemoveStudentPhoto">
                    <a-icon type="close" /> Remove Photo
                  </a-button>
                </div>
              </div>
              <div v-else-if="photoPreview" class="mb-2">
                <img
                  :src="photoPreview"
                  alt="student photo"
                  class="img-fluid border rounded p-1"
                  style="max-height: 150px; object-fit: cover;"
                />
              </div>
              <a-upload
                v-decorator="[
                  'photo',
                  {
                    rules: [
                      { required: false, message: 'Please select a photo' },
                    ],
                  },
                ]"
                :multiple="false"
                :remove="handleRemovePhotoFile"
                :beforeUpload="beforeUpload"
                accept=".jpg,.jpeg,.png,.webp"
              >
                <a-button
                  v-if="
                    form.getFieldValue('photo')
                      ? form.getFieldValue('photo').fileList.length !== 0
                        ? false
                        : true
                      : true
                  "
                >
                  <a-icon type="upload" />
                  {{ photo ? "Change Photo" : "Select File" }}
                </a-button>
              </a-upload>
            </a-form-item>
            <p class="font-italic text-warning">
              Should be JPG/PNG/WEBP and less than 2MB
            </p>
          </div>

          <div class="col-md-3">
            <a-form-item label="Father's Document">
              <div v-if="fatherDoc">
                <a :href="fatherDoc" class="btn btn-sm btn-dark" target="_blank"
                  >View Document</a
                >
              </div>
              <a-upload
                v-decorator="[
                  'father[document]',
                  {
                    rules: [
                      { required: false, message: 'Please select a document!' },
                    ],
                  },
                ]"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUploadDoc"
                accept=".jpg,.jpeg,.png,.pdf"
              >
                <a-button
                  v-if="
                    form.getFieldValue('father[document]')
                      ? form.getFieldValue('father[document]').fileList
                          .length !== 0
                        ? false
                        : true
                      : true
                  "
                >
                  <a-icon type="upload" />
                  {{ fatherDoc ? "Update Document" : "Select File" }}
                </a-button>
              </a-upload>
            </a-form-item>
            <p class="font-italic text-warning">
              Should be JPG/PNG/PDF and less than 2MB
            </p>
          </div>

          <div class="col-md-3">
            <a-form-item label="Mother's Document">
              <div v-if="motherDoc">
                <a :href="motherDoc" class="btn btn-sm btn-dark" target="_blank"
                  >View Document</a
                >
              </div>
              <a-upload
                v-decorator="[
                  'mother[document]',
                  {
                    rules: [
                      { required: false, message: 'Please select a document!' },
                    ],
                  },
                ]"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUploadDoc"
                accept=".jpg,.jpeg,.png,.pdf"
              >
                <a-button
                  v-if="
                    form.getFieldValue('mother[document]')
                      ? form.getFieldValue('mother[document]').fileList
                          .length !== 0
                        ? false
                        : true
                      : true
                  "
                >
                  <a-icon type="upload" />
                  {{ motherDoc ? "Update Document" : "Select File" }}
                </a-button>
              </a-upload>
            </a-form-item>
            <p class="font-italic text-warning">
              Should be JPG/PNG/PDF and less than 2MB
            </p>
          </div>

          <div class="col-md-3">
            <a-form-item label="Guardian's Document">
              <div v-if="guardianDoc">
                <a
                  :href="guardianDoc"
                  class="btn btn-sm btn-dark"
                  target="_blank"
                  >View Document</a
                >
              </div>
              <a-upload
                v-if="form.getFieldValue('guardian[first_name]')"
                v-decorator="[
                  'guardian[document]',
                  {
                    rules: [
                      { required: false, message: 'Please select a document!' },
                    ],
                  },
                ]"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUploadDoc"
                accept=".jpg,.jpeg,.png,.pdf"
              >
                <a-button
                  v-if="
                    form.getFieldValue('guardian[document]')
                      ? form.getFieldValue('guardian[document]').fileList
                          .length !== 0
                        ? false
                        : true
                      : true
                  "
                >
                  <a-icon type="upload" />
                  {{ guardianDoc ? "Update Document" : "Select File" }}
                </a-button>
              </a-upload>
            </a-form-item>
            <p
              v-if="form.getFieldValue('guardian[first_name]')"
              class="font-italic text-warning"
            >
              Should be JPG/PNG/PDF and less than 2MB
            </p>
            <p v-else class="text-danger font-italic mb-1">
              No guardian data exists, cannot upload
            </p>
          </div>
        </div>
          </a-collapse-panel>

          <a-collapse-panel key="9" header="Student Password">
        <div class="row pb-3">
          <!-- password -->
          <div class="col-md-4">
            <a-form-item label="Password">
              <a-input v-decorator="['password']" type="password" />
            </a-form-item>
          </div>
          <!-- confirm password -->
          <div class="col-md-4">
            <a-form-item label="Confirm Password">
              <a-input
                v-decorator="['confirm_password']"
                type="password"
                @blur="handleConfirmBlur"
              />
            </a-form-item>
          </div>
        </div>
          </a-collapse-panel>

          <a-collapse-panel key="10" header="Student Status">
        <div class="row pb-3">
          <div class="col-md-2">
            <a-form-item label="Status">
              <p :style="{ marginBottom: '20px' }">
                <a-checkbox
                  :checked="statusChecked"
                  :disabled="statusDisabled"
                  @change="statusOnChange"
                >
                  {{ statuslabel }}
                </a-checkbox>
              </p>
            </a-form-item>
          </div>
          <!-- Exit Type and Reason - Only show when status is inactive -->
           <template v-if="!statusChecked">
            <div class="col-md-4">
              <a-form-item label="Exit Type" :required="true">
              <a-select
                placeholder="Select exit type"
                v-decorator="[
                'exit_type',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please select exit type!',
                    },
                  ],
                },
              ]"
            >
              <a-select-option value="TC">TC</a-select-option>
              <a-select-option value="Abscond">Abscond</a-select-option>
            </a-select>
            </a-form-item>
            </div>
            <div class="col-md-4">
            <a-form-item label="Exit Reason">
              <a-input
                placeholder="Enter exit reason"
                v-decorator="[
                'exit_reason',
                {
                    rules: [
                      {
                      required: false,
                      message: 'Please input exit reason!',
                      },
                    ],
                  },
                ]"
              />
              </a-form-item>
            </div>
          </template>
        </div>
          </a-collapse-panel>
        </a-collapse>
        <div class="row justify-content-between py-3">
          <div class="col-md-12 text-md-right">
            <a-button key="back" @click="handleCancel" class="mr-3"
              >Cancel</a-button
            >
            <a-button
              key="submit"
              type="primary"
              :loading="loading"
              @click="handleSubmit"
              >Update Student</a-button
            >
          </div>
        </div>
      </a-form>
    </a-drawer>
  </div>
</template>

<script>
import MedicalHistoryList from '@/components/medicalhistory/List/index'
import { find, remove, debounce, mapValues } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import { makeFields } from '../fields'
import { appointmentTypes, categoryTypes } from '../data'
import {
  countryCodes,
  qualifications,
  occupations,
  genderTypes,
  bloodGroups,
  idTypes,
  nameSuffixes,
} from '@/services/globaldata'
import { compressImage } from '@/utils/imageCompressor'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: true,
  mapping: function (value) {
    if (value !== null && value !== undefined) {
      if (typeof value === 'boolean') {
        return +value ? '1' : '0'
      }
      if (value === 1 || value === 0) {
        return value // convert to '1' or '0'
      }
      if (typeof value === 'object' && value._isAMomentObject === true) {
        return moment(value).format('YYYY-MM-DD')
      }
      return value
    }
    return ''
  },
}

export default {
  name: 'EditStudent',
  components: {
    MedicalHistoryList,
  },
  mounted: function () {
    // this.form = this.$form.createForm(this)
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.getClasses()
        this.getHouses()
      })
      .catch((error) => {
        console.log(error)
      })

    this.$eventBus.$on('openStudentEditModal', this.showModal)
  },
  created() {
    this.fetchSiblings = debounce(this.fetchSiblings, 500)
    this.$http
      .get('/api/student/type/all')
      .then(({ data }) => {
        this.studentTypes = data.data
      })
      .catch((error) => {
        console.log(error)
      })
  },
  props: ['session'],
  data: function () {
    return {
      form: this.$form.createForm(this),
      confirmDirty: false,
      loading: false,
      visible: false,
      fetching: false,
      sectionSpinning: false,
      classSpinning: false,
      dateFormat: 'DD-MM-YYYY',
      schoolClasses: [],
      schoolSessions: [],
      classSubjects: [],
      sections: [],
      fileList: [],
      siblingsData: [],
      selectedSiblings: [],
      appointmentTypes,
      genderTypes,
      categoryTypes,
      countryCodes,
      qualifications,
      occupations,
      idTypes,
      bloodGroups,
      nameSuffixes,
      medicalInfoCount: 0,
      medicalInfos: [],
      hostellerOptions: [
        { name: 'Hosteller', value: '1' },
        { name: 'Day Scholar', value: '0' },
      ],
      sicOptions: [
        { name: 'JEE', value: 'jee' },
        { name: 'NEET', value: 'neet' },
      ],
      schoolHouses: [],
      previousClasses: [
        { name: 'Pre-Nursery', value: 'Pre-Nursery ' },
        { name: 'Nursery', value: 'Nursery' },
        { name: 'LKG', value: 'LKG' },
        { name: 'UKG', value: 'UKG' },
        { name: 'Class 1', value: 'Class 1' },
        { name: 'Class 2', value: 'Class 2' },
        { name: 'Class 3', value: 'Class 3' },
        { name: 'Class 4', value: 'Class 4' },
        { name: 'Class 5', value: 'Class 5' },
        { name: 'Class 6', value: 'Class 6' },
        { name: 'Class 7', value: 'Class 7' },
        { name: 'Class 8', value: 'Class 8' },
        { name: 'Class 9', value: 'Class 9' },
        { name: 'Class 10', value: 'Class 10' },
        { name: 'Class 11', value: 'Class 11' },
        { name: 'Class 12', value: 'Class 12' },
      ],
      photo: null,
      photoPreview: null,
      fatherDoc: null,
      motherDoc: null,
      guardianDoc: null,
      studentData: [],
      studentTypes: [],
      isDayCare: 0,
      statusChecked: true,
      statusDisabled: false,
      showOtherExamTypeField: false,
      activeKey: [],
      subActiveKey: [],
    }
  },
  computed: {
    ...mapState(['settings', 'user']),
    currentSession: function () {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    statuslabel() {
      const { statusChecked } = this
      return `${statusChecked ? 'Active' : 'Inactive'}`
    },
  },
  methods: {
    moment,
    validateSingleCheckbox(rule, value, callback) {
      if (value && value.length > 1) {
        callback(new Error('Only one exam type can be selected.'))
      } else {
        callback() // Validation passes
      }
    },
    handleCheckboxChange(checkedValues) {
      let selectedValue = null

      const currentFieldValue = this.form.getFieldValue('previous_exam_type')

      if (
        checkedValues.length >
        (currentFieldValue ? currentFieldValue.length : 0)
      ) {
        selectedValue = checkedValues[checkedValues.length - 1]
        this.form.setFieldsValue({
          previous_exam_type: [selectedValue],
        })
      } else if (
        checkedValues.length <
        (currentFieldValue ? currentFieldValue.length : 0)
      ) {
        selectedValue = checkedValues.length === 1 ? checkedValues[0] : null
        this.form.setFieldsValue({
          previous_exam_type: checkedValues,
        })
      } else if (
        checkedValues.length === 1 &&
        currentFieldValue &&
        currentFieldValue.length === 1 &&
        checkedValues[0] === currentFieldValue[0]
      ) {
        selectedValue = null
        this.form.setFieldsValue({
          previous_exam_type: [],
        })
      } else {
        selectedValue = checkedValues.length === 1 ? checkedValues[0] : null
      }

      this.showOtherExamTypeField = selectedValue === 'other'

      if (!this.showOtherExamTypeField) {
        this.form.setFieldsValue({
          previous_exam_other: undefined,
        })
      }

      // this.$nextTick(() => {
      //   this.form.validateFields(['previous_exam_type', 'previous_exam_other'], { force: true })
      // })
    },
    showModal(studentId) {
      this.studentId = studentId
      this.activeKey = ['1', '3', '10'] // Default core sections
      this.visible = true
      this.fetchStudent(studentId)
    },
    disabledDate(current) {
      // Can not select days after today
      return current > moment().endOf('day')
    },
    addCommaOnList(index, listSize) {
      if (index < listSize.length - 1) {
        return ','
      }
      return ''
    },
    onDaycareChange(value) {
      this.isDayCare = value
    },
    statusOnChange(e) {
      this.statusChecked = e.target.checked
    },
    fetchStudent(studentId) {
      this.loading = true
      this.$http
        .get(`/api/student/${studentId}`, {
          params: {
            session_id: this.session,
          },
        })
        .then(({ data }) => {
          const classId = data.data.enrollment.class_id
          const studentSessionId = data.data.enrollment.session_id
          const studentData = data.data
          this.sectionSpinning = false

          this.studentData = data.data
          this.statusChecked = studentData.status
          this.isDayCare = data.data.enrollment.is_daycare
          this.form.resetFields()
          this.fileList = []

          this.photo = studentData.photo || null
          this.photoPreview = null
          if (find(studentData.student_parents, ['relation', 'father'])) {
            this.fatherDoc =
              find(studentData.student_parents, ['relation', 'father'])
                .document || null
          } else {
            this.fatherDoc = null
          }
          // this.motherDoc = find(studentData.student_parents, ['relation', 'mother']).document || null
          if (find(studentData.student_parents, ['relation', 'mother'])) {
            this.motherDoc =
              find(studentData.student_parents, ['relation', 'mother'])
                .document || null
          } else {
            this.motherDoc = null
          }

          if (find(studentData.student_parents, ['relation', 'guardian'])) {
            this.guardianDoc =
              find(studentData.student_parents, ['relation', 'guardian'])
                .document || null
          } else {
            this.guardianDoc = null
          }

          if (studentData.has_sibling) {
            this.selectedSiblings = studentData.siblings.map((element) => {
              return element.student_id
            })
            this.getSelectedSiblings(this.selectedSiblings)
          }

          if (classId) {
            this.$http
              .get(
                `/api/section/class/${classId}?session_id=` + studentSessionId
              )
              .then(({ data }) => {
                this.sections = data.data
                this.$http
                  .get(`/api/subject/class/${classId}`)
                  .then(({ data }) => {
                    this.classSubjects = data.data

                    let subjectPromise = new Promise(function (
                      resolve,
                      reject
                    ) {
                      const fieldsData = mapValues(
                        { ...makeFields(studentData) },
                        function (value) {
                          return value !== null ? value : undefined
                        }
                      )
                      resolve(fieldsData)
                    })

                    subjectPromise.then((fieldsData) => {
                      // If previous_exam_type is 'other', show the field
                      this.showOtherExamTypeField =
                        fieldsData.previous_exam_type === 'other'
                      // Ensure previous_exam_type is an array for the checkbox group
                      if (fieldsData.previous_exam_type) {
                        fieldsData.previous_exam_type = [
                          fieldsData.previous_exam_type,
                        ]
                      } else {
                        fieldsData.previous_exam_type = []
                      }

                      const Sic = []
                      if (studentData.jee) {
                        Sic.push('jee')
                      }
                      if (studentData.neet) {
                        Sic.push('neet')
                      }
                      fieldsData.sic = Sic
                      // Set active keys based on data presence
                      const keys = ['1', '3', '10']
                      const subKeys = []
                      if (
                        studentData.contact &&
                        (studentData.contact.address ||
                          studentData.contact.phone ||
                          studentData.contact.email)
                      ) {
                        keys.push('2')
                      }
                      if (
                        studentData.previous_school_name ||
                        studentData.previous_class ||
                        studentData.previous_mark ||
                        studentData.previous_board
                      ) {
                        keys.push('4')
                      }
                      if (
                        studentData.student_parents &&
                        studentData.student_parents.length > 0
                      ) {
                        keys.push('5')
                        if (
                          studentData.student_parents.some(
                            (p) =>
                              p.relation === 'father' &&
                              (p.first_name || p.last_name)
                          )
                        ) {
                          subKeys.push('father')
                          if (
                            studentData.student_parents.some(
                              (p) =>
                                p.relation === 'father' &&
                                p.contact &&
                                (p.contact.address ||
                                  p.contact.phone ||
                                  p.contact.email)
                            )
                          ) {
                            subKeys.push('fatherAddress')
                          }
                        }
                        if (
                          studentData.student_parents.some(
                            (p) =>
                              p.relation === 'mother' &&
                              (p.first_name || p.last_name)
                          )
                        ) {
                          subKeys.push('mother')
                          if (
                            studentData.student_parents.some(
                              (p) =>
                                p.relation === 'mother' &&
                                p.contact &&
                                (p.contact.address ||
                                  p.contact.phone ||
                                  p.contact.email)
                            )
                          ) {
                            subKeys.push('motherAddress')
                          }
                        }
                        if (
                          studentData.student_parents.some(
                            (p) =>
                              p.relation === 'guardian' &&
                              (p.first_name || p.last_name)
                          )
                        ) {
                          subKeys.push('guardian')
                          if (
                            studentData.student_parents.some(
                              (p) =>
                                p.relation === 'guardian' &&
                                p.contact &&
                                (p.contact.address ||
                                  p.contact.phone ||
                                  p.contact.email)
                            )
                          ) {
                            subKeys.push('guardianAddress')
                          }
                        }
                      }
                      if (
                        studentData.blood_group ||
                        studentData.allergies ||
                        studentData.major_illness ||
                        (studentData.student_medical_details &&
                          studentData.student_medical_details.length > 0)
                      ) {
                        keys.push('6')
                      }
                      if (
                        studentData.student_meta &&
                        (studentData.student_meta.sports ||
                          studentData.student_meta.orphaned ||
                          studentData.student_meta.idp ||
                          studentData.student_meta.tattooed)
                      ) {
                        keys.push('7')
                      }
                      if (
                        this.photo ||
                        this.fatherDoc ||
                        this.motherDoc ||
                        this.guardianDoc
                      ) {
                        keys.push('8')
                      }
                      keys.push('9')
                      this.activeKey = keys
                      this.subActiveKey = subKeys

                      this.$nextTick(() => {
                        this.form.setFieldsValue({ ...fieldsData })
                      })

                      this.loading = false
                    })
                  })
                  .catch((error) => {
                    console.log(error)
                  })
                this.sectionSpinning = false
              })
              .catch((error) => {
                console.log(error)
              })
          } else {
            let subjectPromise = new Promise(function (resolve, reject) {
              const fieldsData = mapValues(
                { ...makeFields(studentData) },
                function (value) {
                  return value !== null ? value : undefined
                }
              )
              resolve(fieldsData)
            })

            subjectPromise.then((fieldsData) => {
              this.showOtherExamTypeField =
                fieldsData.previous_exam_type === 'other'
              // Ensure previous_exam_type is an array for the checkbox group
              if (fieldsData.previous_exam_type) {
                fieldsData.previous_exam_type = [fieldsData.previous_exam_type]
              } else {
                fieldsData.previous_exam_type = []
              }
              const Sic = []
              if (studentData.jee) {
                Sic.push('jee')
              }
              if (studentData.neet) {
                Sic.push('neet')
              }
              fieldsData.sic = Sic

              // Set active keys based on data presence
              const keys = ['1', '3', '10']
              const subKeys = []
              if (
                studentData.contact &&
                (studentData.contact.address ||
                  studentData.contact.phone ||
                  studentData.contact.email)
              ) {
                keys.push('2')
              }
              if (
                studentData.previous_school_name ||
                studentData.previous_class ||
                studentData.previous_mark ||
                studentData.previous_board
              ) {
                keys.push('4')
              }
              if (
                studentData.student_parents &&
                studentData.student_parents.length > 0
              ) {
                keys.push('5')
                if (
                  studentData.student_parents.some(
                    (p) =>
                      p.relation === 'father' && (p.first_name || p.last_name)
                  )
                ) {
                  subKeys.push('father')
                  if (
                    studentData.student_parents.some(
                      (p) =>
                        p.relation === 'father' &&
                        p.contact &&
                        (p.contact.address || p.contact.phone || p.contact.email)
                    )
                  ) {
                    subKeys.push('fatherAddress')
                  }
                }
                if (
                  studentData.student_parents.some(
                    (p) =>
                      p.relation === 'mother' && (p.first_name || p.last_name)
                  )
                ) {
                  subKeys.push('mother')
                  if (
                    studentData.student_parents.some(
                      (p) =>
                        p.relation === 'mother' &&
                        p.contact &&
                        (p.contact.address || p.contact.phone || p.contact.email)
                    )
                  ) {
                    subKeys.push('motherAddress')
                  }
                }
                if (
                  studentData.student_parents.some(
                    (p) =>
                      p.relation === 'guardian' && (p.first_name || p.last_name)
                  )
                ) {
                  subKeys.push('guardian')
                  if (
                    studentData.student_parents.some(
                      (p) =>
                        p.relation === 'guardian' &&
                        p.contact &&
                        (p.contact.address || p.contact.phone || p.contact.email)
                    )
                  ) {
                    subKeys.push('guardianAddress')
                  }
                }
              }
              if (
                studentData.blood_group ||
                studentData.allergies ||
                studentData.major_illness ||
                (studentData.student_medical_details &&
                  studentData.student_medical_details.length > 0)
              ) {
                keys.push('6')
              }
              if (
                studentData.student_meta &&
                (studentData.student_meta.sports ||
                  studentData.student_meta.orphaned ||
                  studentData.student_meta.idp ||
                  studentData.student_meta.tattooed)
              ) {
                keys.push('7')
              }
              if (
                this.photo ||
                this.fatherDoc ||
                this.motherDoc ||
                this.guardianDoc
              ) {
                keys.push('8')
              }
              keys.push('9')
              this.activeKey = keys
              this.subActiveKey = subKeys

              this.$nextTick(() => {
                this.form.setFieldsValue({ ...fieldsData })
              })
              this.loading = false
            })
          }
        })
    },
    addAdditionalMediInfo() {
      this.medicalInfos.push(this.medicalInfoCount++)
    },
    removeAdditionalMediInfo(i) {
      this.$confirm({
        title: `Are you sure you want to remove this?`,
        content: `Click on the OK button to remove this additional medical data!`,
        onOk: () => {
          this.medicalInfos = remove(this.medicalInfos, function (n) {
            return n !== i
          })
        },
        onCancel: () => {},
      })
    },
    // handleClassSelect(value) {
    //   this.sectionSpinning = true
    //   this.$http.get(`/api/section/class/${value}`)
    //     .then(({ data }) => {
    //       this.sections = data.data

    //       this.$http.get(`/api/subject/class/${value}`)
    //         .then(({ data }) => {
    //           this.classSubjects = data.data
    //         })
    //         .catch(error => {
    //           console.log(error)
    //         })
    //       this.sectionSpinning = false
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    getClasses: function () {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getHouses: function () {
      this.classSpinning = true
      this.$http
        .get('/api/house', {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.schoolHouses = data.data
          this.classSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['enrollment[section_id]'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http
        .get(`/api/section/class/${value}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false

          this.getClassSectionSubjects(value)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getClassSectionSubjects(value) {
      this.$http
        .get(`/api/subject/class/${value}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.classSubjects = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleRemovePhotoFile() {
      this.photoPreview = null
      return true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    handleRemoveStudentPhoto() {
      this.$confirm({
        title: 'Remove Student Photo?',
        content: 'Are you sure you want to remove this student photo?',
        okText: 'Yes, Remove',
        okType: 'danger',
        onOk: () => {
          this.$http
            .delete(`/api/upload_photo/student/${this.studentData.id}`)
            .then(() => {
              this.photo = null
              this.$notification['success']({
                message: 'Successfully removed',
                description: 'Student photo removed successfully!',
              })
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        },
      })
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('You can upload only image files!')
        return false
      }

      const isLt2M = file.size / 1024 / 1024 <= 2
      if (!isLt2M) {
        this.$message.error('Image must be less than 2MB!')
        return false
      }

      // Start background compression immediately upon file selection
      file.compressedPromise = compressImage(file)
      const reader = new FileReader()
      reader.onload = (e) => {
        this.photoPreview = e.target.result
      }
      reader.readAsDataURL(file)

      return false
    },
    beforeUploadDoc(file) {
      this.fileList = [...this.fileList, file]
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isPDF = file.type === 'application/pdf'
      if (!(isJPG || isPNG || isPDF)) {
        this.$message.error('You can upload only JPG, PNG or PDF file!')
        this.handleRemove(file)
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
        this.handleRemove(file)
      }
      return false
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    fetchSiblings(value) {
      this.siblingsData = []
      this.fetching = true
      this.$http
        .get('/api/student', {
          params: {
            search: value,
          },
        })
        .then(({ data }) => {
          this.siblingsData = data.data
          this.fetching = false
        })
    },
    // getSelectedSiblings(siblingsArray) {
    //   this.siblingsData = []
    //   siblingsArray.map(siblingId => {
    //     this.fetching = true
    //     this.$http.get('/api/student/' + siblingId, {
    //       params: {
    //         session_id: this.session,
    //       },
    //     }).then(({ data }) => {
    //       this.siblingsData.push(data.data)
    //       this.fetching = false
    //     })
    //   })
    // },
    handleSiblingsChange(value) {
      Object.assign(this, {
        value,
        siblingsData: [],
        fetching: false,
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    handleSubmit(e) {
      this.loading = true

      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update student: ${values.first_name} ${values.last_name}?`,
            content: `Click on the OK button to update the student!`,
            onOk: async () => {
              this.loading = true

              if (!values.alt_phone) {
                // values.alt_country_code = undefined
                delete values.alt_country_code
              }

              delete values.confirm_password
              delete values.father_contact_same_as_student
              delete values.mother_contact_same_as
              delete values.guardian_contact_same_as
              delete values.has_major_illness

              // values.confirm_password = undefined
              // values.father_contact_same_as_student = undefined
              // values.mother_contact_same_as = undefined
              // values.guardian_contact_same_as = undefined
              // values.has_major_illness = undefined

              // console.log(values)

              // Get student Photo
              let photoFile = null
              if (values.photo) {
                if (values.photo.fileList.length !== 0) {
                  photoFile = values.photo.file
                  // values.photo = undefined
                }
              }
              delete values.photo

              if (photoFile) {
                if (photoFile.compressedPromise) {
                  photoFile = await photoFile.compressedPromise
                } else {
                  photoFile = await compressImage(photoFile)
                }

                if (photoFile.size / 1024 / 1024 > 2) {
                  this.$message.error('Compressed image exceeds 2MB limit!')
                  this.loading = false
                  return
                }
              }

              // Get Father Document
              let fatherDocFile = null
              // Check if values.father exists before checking document
              if (values.father && values.father.document) {
                if (values.father.document.fileList.length !== 0) {
                  fatherDocFile = values.father.document.file
                }
                // Delete the property from the object so it doesn't interfere with FormData
                delete values.father.document
              }

              // Get Mother Document
              let motherDocFile = null
              // Check if values.mother exists before checking document
              if (values.mother && values.mother.document) {
                if (values.mother.document.fileList.length !== 0) {
                  motherDocFile = values.mother.document.file
                }
                delete values.mother.document
              }

              // Get Guardian Document
              let guardianDocFile = null
              // Check if values.guardian exists before checking document
              if (values.guardian && values.guardian.document) {
                if (values.guardian.document.fileList.length !== 0) {
                  guardianDocFile = values.guardian.document.file
                }
                delete values.guardian.document
              }

              // Siblings Data
              if (values.has_sibling) {
                let siblingsId = values.sibling_id.map(($element) => {
                  return $element.key
                })
                values.sibling_id = siblingsId
              }

              if (
                values.previous_exam_type &&
                Array.isArray(values.previous_exam_type) &&
                values.previous_exam_type.length > 0
              ) {
                values.previous_exam_type = values.previous_exam_type[0]
              } else {
                values.previous_exam_type = undefined
              }
              // --- NEW: Handle sic as is_jee and is_neet ---
              const Jee = (values.sic || []).includes('jee')
              const Neet = (values.sic || []).includes('neet')
              delete values.sic

              let formData = window.jsonToFormData(values, options)
              formData.append('jee', Jee ? 1 : 0)
              formData.append('neet', Neet ? 1 : 0)

              if (photoFile) {
                formData.append('photo', photoFile)
              }
              if (fatherDocFile) {
                formData.append('father[document]', fatherDocFile)
              }
              if (motherDocFile) {
                formData.append('mother[document]', motherDocFile)
              }
              if (guardianDocFile) {
                formData.append('guardian[document]', guardianDocFile)
              }
              formData.append('is_daycare', this.isDayCare ? 1 : 0)
              formData.append('status', this.statusChecked ? 1 : 0)
              formData.append('_method', 'PATCH')

              // for (var pair of formData.entries()) {
              //   console.log(pair[0] + ', ' + pair[1])
              // }

              this.$http
                .post('/api/student/' + this.studentId, formData)
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.$notification['success']({
                    message: 'Student successfully updated!',
                    description: `${data.data.first_name} ${data.data.last_name} updated successfully!`,
                  })
                  this.fileList = []
                  // this.fetchStudent(this.studentId)
                  this.visible = false
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.loading = false
      this.classSubjects = []
      this.form.resetFields()
    },
  },
}
</script>

<style scoped>
::v-deep .ant-upload-list-item .anticon-delete {
  color: #f5222d;
}
.ant-drawer-close-x {
  margin-right: 0.7rem;
}
.photo-remove-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 16px;
  color: #fff;
  background: rgba(255, 0, 0, 0.75);
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.photo-remove-icon:hover {
  background: rgba(255, 0, 0, 1);
}
</style>
